import { STUDIOS_PODCAST } from '../../lib/homeContent.js';
import { PodcastPlatformIcon } from './podcastPlatformIcons.jsx';

export default function HomeStudiosPodcast() {
  const { eyebrow, title, description, ctaLabel, watchUrl, thumbnailUrl, embedUrl, platforms } =
    STUDIOS_PODCAST;

  return (
    <section
      className="max-w-page mx-auto px-4 sm:px-6 py-10 sm:py-12"
      aria-labelledby="home-studios-heading"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-10 items-center border border-black bg-white p-5 sm:p-6">
        <div className="lg:order-2">
          <p className="font-display text-[10px] font-bold tracking-display-md uppercase text-hxd-orange m-0 mb-2">
            {eyebrow}
          </p>
          <h2
            id="home-studios-heading"
            className="font-sans text-[clamp(1.125rem,2.2vw,1.5rem)] font-extrabold leading-tight text-hxd-orange m-0"
          >
            {title}
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-[#525252] m-0">{description}</p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a
              href={watchUrl}
              className="hxd-btn hxd-btn-primary text-[13px]"
              target={watchUrl.startsWith('http') ? '_blank' : undefined}
              rel={watchUrl.startsWith('http') ? 'noopener noreferrer' : undefined}
            >
              {ctaLabel ?? 'Watch now'}
            </a>
            {platforms?.length > 0 ? (
              <div className="flex flex-wrap items-center gap-2">
                {platforms.map(({ id, label, url }) => (
                  <a
                    key={id}
                    href={url}
                    className="hxd-podcast-platform-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <PodcastPlatformIcon platformId={id} />
                    <span>{label}</span>
                  </a>
                ))}
              </div>
            ) : null}
          </div>
        </div>

        <div className="aspect-video bg-[#0A0A0A] border border-black overflow-hidden flex items-center justify-center lg:order-1">
          {embedUrl ? (
            <iframe
              src={embedUrl}
              title={title}
              className="w-full h-full border-0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <a
              href={watchUrl}
              className="block w-full h-full relative group"
              target={watchUrl.startsWith('http') ? '_blank' : undefined}
              rel={watchUrl.startsWith('http') ? 'noopener noreferrer' : undefined}
            >
              <img
                src={thumbnailUrl}
                alt=""
                className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity"
              />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="w-14 h-14 rounded-full bg-hxd-orange/90 flex items-center justify-center text-white text-2xl pl-1">
                  ▶
                </span>
              </span>
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
